(() => {
  let engraving_added = false;
  const locations = [];
  const retrieveCart = () => {
    return window.Shopify.getCart();
  };

  const initCustomEngraverLogic = () => {
    startEngraving();

    const $atc = $(`.product-personalizer`).siblings(`.purchase-details`).find(`button[data-personalized]`);
  
    // Handle personalized
    $(document).on(`click`, `.js-add-engraving`, (e) => {
      $atc.attr(`data-personalized`, true);
    });
  
    // Handle unpersonalized
    $(document).on(`click`, `.product-personalizer .personalizer__btn-remove`, (e) => {
      $atc.attr(`data-personalized`, false);
    });
  };

  const initEngraver = () => {
    $(`[data-engraver-location]`).each((index, el) => locations.push($(el).data(`engraverLocation`)));
    
    $(window).on(`resize scroll`, (e) => {
      if ($(`[data-engraver-drawer]`).hasClass(`personalizer__popup--active`)) { updatePopupPosition(); }
    });

    $(`[data-engraver-trigger]`).on(`click`, onEngraverClick);
    $(`[data-engraver-overlay]`).on(`click`, onOverlayClick);
    $(`[data-engraver-close]`).on(`click`, onOverlayClick);
    $(`[data-engraver-remove]`).on(`click`, (e) => {
      e.stopPropagation();
      e.preventDefault();
      cancelEngraving(false);
    });
    $(`[data-engraver-input]`).on(`change keyup paste`, onInputUpdate);
    $(`[data-engraver-font]`).on(`change`, onFontChange);
    $(`[data-engraving-add-to-cart]`).on(`click`, saveEngraving);
  };

  const updatePopupPosition = () => {
    let previous_header_height = 0;

    if ($(`.js-header-container`)) {
      let header_height = $(`.js-header-container`).height();
      if (header_height) {
        if (previous_header_height != header_height) {
          $(`[data-engraver-drawer]`).css(`padding-top`, `${header_height + 40}px`);
        }
        previous_header_height = header_height;
      }
    }
  };

  const startEngraving = () => {
    $(`[data-engraver-input], [data-engraver-font]`).prop(`disabled`, false);
    toggleEngraverDisplay();
    updatePopupPosition();
  };
  const cancelEngraving = (toggle = true) => {
    $(`input#add-engraving`).prop(`checked`, false);
    $(`[data-engraver-input]`).each((i, input) => { $(input).val(``).trigger(`change`); });
    $(`[data-engraver-input], [data-engraver-font]`).prop(`disabled`, true);
    $(`[data-engraver-trigger]`).toggleClass(`engraver__trigger--added`, false);
    if (toggle) { toggleEngraverDisplay(); }
    $('.js-unique-property').attr('name', '').val(``);
    document.querySelectorAll(`[data-engraver-computed]`).forEach((el) => el.remove());
    document.querySelectorAll(`[data-engraver-hidden-input]`).forEach((el) => el.removeAttribute(`name`));
    $(`[data-engraver-drawer]`).toggleClass(`personalizer__popup--active`, false);
    engraving_added = false;
    $(`.product-personalizer`).siblings(`.purchase-details`).find(`button[data-personalized]`).attr(`data-personalized`, false);
  };
  const toggleEngraverDisplay = () => {
    $(`[data-engraver-drawer]`).toggleClass(`personalizer__popup--active`);
    $(`[data-engraver-overlay]`).toggleClass(`personalizer__overlay--show`);
    $(`body`).toggleClass(`overflow-hidden`, $(`[data-engraver-drawer]`).hasClass(`personalizer__popup--active`));
    $(`html`).toggleClass(`overflow-hidden`, $(`[data-engraver-drawer]`).hasClass(`personalizer__popup--active`));
  };
  const onEngraverClick = (e) => {
    e.preventDefault();
    if (engraving_added) { return; }
    initCustomEngraverLogic();
  };
  const onOverlayClick = (e) => {
    e.preventDefault();
    if (engraving_added) {
      return toggleEngraverDisplay();
    }
    cancelEngraving();
  };
  const onInputUpdate = (e) => {
    const $input = $(e.currentTarget);
    const $input_wrapper = $input.parents(`.engraver__input`);
    const $input_group = $input.parents(`.engraver__inputGroup`);

    // Update Input Character Count
    const input_value = $input.val();
    const input_length = input_value.length;
    $input_wrapper.find(`[data-engraver-input-length]`).html(input_length);

    // Update Input Group Character Count
    const $sibling_input_lengths = $input_wrapper.siblings(`.engraver__input`).map((i, el) => { return $(el).find(`[data-engraver-input]`).val().toLowerCase().length });
    const total_length = [input_length, ...$sibling_input_lengths].reduce((accumulator, length) => { return accumulator + length; }, 0);
    const $counter = $input_group.find(`[data-engraver-remaining-count]`);
    const max_length = $counter.data(`total`);
    $counter.html(max_length - total_length);

    // Update Engraver Preview
    const location = $input.parents(`[data-engraver-location]`).data(`engraverLocation`);
    $(`[data-engraver-preview="${location}"] [data-engraver-text="${$input_wrapper.index()}"]`).html(input_value);
  };
  const onFontChange = (e) => {
    const $input = $(e.currentTarget);
    const location = $input.parents(`[data-engraver-location]`).data(`engraverLocation`);
    $(`[data-engraver-preview="${location}"]`).css(`font-family`, $input.val());
  };
  const saveEngraving = (e) => {
    e.preventDefault();
    let has_values = false;
    const double_engraving = locations.length > 1;
    $(`[data-engraver-input]`).each((i, el) => {
      if (has_values) { return false; }
      if (el.value) { has_values = true; }
    });
    if (!has_values) { return cancelEngraving(); }

    for (const location of locations) {
      // Build hidden fields
      const $location = $(`[data-engraver-location="${location}"]`);
      const $fields = $location.find(`[data-engraver-input]`);
      const field_values = [...$fields.map((i, field) => $(field).val())];
      const $font = $location.find(`[data-engraver-font]`);

      if (field_values.filter((val) => val !== '').length > 0) {
        const existing_main_field = document.querySelector(`[data-engraver-computed="${location}-main"]`);
        const main_field = existing_main_field || document.createElement(`input`);
        main_field.setAttribute(`data-engraver-computed`, `${location}-main`);
        main_field.setAttribute(`type`, `hidden`);
        main_field.setAttribute(`name`, `properties[${double_engraving ? `${location} ` : ``}Engraving Added for $15]`);
        main_field.setAttribute(`value`, `Added`);
        if (!existing_main_field) { document.querySelector(`[data-engraver-drawer]`).appendChild(main_field); }

        const existing_lines_field = document.querySelector(`[data-engraver-computed="${location}-fields"]`);
        const lines_field = existing_lines_field || document.createElement(`input`);
        lines_field.setAttribute(`data-engraver-computed`, `${location}-fields`);
        lines_field.setAttribute(`type`, `hidden`);
        lines_field.setAttribute(`name`, `properties[${double_engraving ? `${location} ` : ``}Engraving]`);
        lines_field.setAttribute(`value`, `(${$font.val()}) ${field_values.join(` / `)}`);
        if (!existing_lines_field) { document.querySelector(`[data-engraver-drawer]`).appendChild(lines_field); }
        $('[data-engraver-hidden-input="engrave-product-id"]').attr('name', 'properties[_engraving_product_id]');
        $('[data-engraver-hidden-input="engrave-product-price"]').attr('name', 'properties[_engraving_product_price]');
        $('[data-engraver-hidden-input="js-unique-property"]').attr(`name`, $('[data-engraver-hidden-input="js-unique-property"]').data(`name`)).val(Math.floor(Math.random() * 99999999) + 1);
        $(`.product-personalizer`).siblings(`.purchase-details`).find(`button[data-personalized]`).attr(`data-personalized`, false);
      } else {
        document.querySelector(`[data-engraver-computed="${location}-main"]`)?.remove();
        document.querySelector(`[data-engraver-computed="${location}-fields"]`)?.remove();
      }
    }

    $(`[data-engraver-trigger]`).toggleClass(`engraver__trigger--added`, true);
    toggleEngraverDisplay();
  };


  initEngraver();
})();